import { I } from "@fullcalendar/core/internal-common";
import { BaseEntity } from "../system";
import { IPart } from "../Part";
import { IAccount } from "../account/IAccount";
import { IBasket } from "../Basket";

export interface IInvoice extends BaseEntity {
  status: InvoiceStatus;
  invoiceNumber: number;
  reference: string;
  invoiceDate: string;
  dueDate: string;
  subTotal: number;
  invoiceTotal: number;
  amountPaid: number;
  paymentMethod: PaymentMethod;
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  town: string;
  county: string;
  postcode: string;
  notes?: string;
  deleted?: string;
  isGlobalSale?: boolean | null;
  accountId: string;
  account: IAccount | null;

  basketId: string | null;
  basket: IBasket | null;

  items: IInvoiceItem[];
}

export enum InvoiceStatus {
  Draft,
  Approved,
  Paid,
  Credit
}

export enum PaymentMethod {
  Cash,
  Card,
  Ebay,
  Stripe,
}

export interface IInvoiceItem extends BaseEntity {
  description: string | null;
  quantity: number;
  unitPrice: number;
  discount: string | null;
  accountCode: string | null;
  taxRate: number | null;
  notes: string | null;
  invoiceId: string;
  invoice: IInvoice | null;
  deleted: string | null;

  partId: string | null;
  part: IPart | null;
  isMarginScheme?: boolean;

  /** Make/model/year of the donor car, populated by GET /invoice/{id} for part lines. */
  donorVehicleDescription: string | null;
  donorVehicleStockNumber: string | null;
  donorVehicleVrm: string | null;
}